<template>
    <v-form ref="widgetForm">
        <v-container v-if="widgetId" style="max-width: 1200px">
            <v-layout row wrap>
                <v-flex xs12 md4>
                    <v-checkbox
                        v-model="useReferral"
                        label="Реферальная ссылка"
                        @change="onUseReferralChange"
                    />
                    <v-text-field
                        v-model="widgetQrUrl"
                        label="URL"
                        :disabled="useReferral"
                        validate-on-blur
                        style="width: 300px"
                    />
                    <qr-code :url="widgetQrUrl"/>
                </v-flex>
                <v-flex xs12 md8 style="align-self: flex-end">
                    <v-layout row wrap>
                        <v-flex xs12 mb-3>
                            <b>{{'&lt;BODY&gt;'}}</b>
                        </v-flex>
                        <v-flex xs12 mb-3>
                            <span>
                                Вставьте код в "тело" вашего сайта в блок, где должен отображаться виджет. У вас должен быть доступ к редактированию кода сайта. Если такого нет, используйте вариант ниже.
                            </span>
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 mb-3>
                            <v-btn
                                v-clipboard="widgetCode"
                                onclick="PNotify.success('Код скопирован')"
                                class="widget-submit-button submit-button block">Скопировать</v-btn>
                        </v-flex>
                        <v-flex xs12 mb-3>
                            <div class="widget-code">
                                <span>{{widgetCode}}</span>
                            </div>
                        </v-flex>
                        <v-flex xs12 mb-3>
                            <b>{{'&lt;/BODY&gt;'}}</b>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 mb-3>
                            <span>
                                Разместите ссылку на расчет в социальных сетях, мессенджерах или отправляйте клиенту
                            </span>
                        </v-flex>
                        <v-flex xs12 sm6 md3 lg2 mb-3>
                            <v-btn
                                v-clipboard="widgetLink"
                                onclick="PNotify.success('Ссылка скопирована')"
                                class="widget-submit-button submit-button block">Скопировать</v-btn>
                        </v-flex>
                        <v-flex xs12 mb-3>
                            <div class="widget-code">
                                <span>{{widgetLink}}</span>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>

            <v-layout row wrap>
                <v-card style="width: 100%">
                    <v-toolbar color="#00ba57" dark>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn icon dark v-on="on"
                                       @click.stop="showReferralLinkDialog = true"
                                >
                                    <v-icon large>add</v-icon>
                                </v-btn>
                            </template>
                            <span>Добавить новую реферальную ссылку</span>
                        </v-tooltip>
                        <v-spacer></v-spacer>
                        <v-toolbar-title class="toolbar-title">Реферальные ссылки</v-toolbar-title>
                    </v-toolbar>

                    <v-list>
                        <template v-for="(item, index) in linksList">
                            <v-divider v-if="index > 0"/>
                            <v-list-tile class="my-3"
                                         :key="item.id"
                            >
                                <v-list-tile-content>
                                    <v-container px-0 mx-0 style="max-width:100%;">
                                        <v-layout row>
                                            <v-flex class="nowrap-text">
                                                <span style="color:gray;">
                                                    {{item.link}}
                                                </span>
                                                <br>
                                                <span>
                                                    {{item.getpolis_link ? item.getpolis_link : "Здесь будет реферальная ссылка для клиента"}}
                                                </span>
                                            </v-flex>
                                            <v-spacer></v-spacer>
                                            <div v-if="item.getpolis_link" style="align-self: center">
                                                <v-btn flat icon color="#00ba57"
                                                       v-clipboard="item.getpolis_link"
                                                       onclick="PNotify.success('Ссылка скопирована в буфер обмена')"
                                                >
                                                    <v-icon medium>content_copy</v-icon>
                                                </v-btn>
                                            </div>
                                            <div v-if="item.getpolis_link" style="align-self: center">
                                                <v-btn flat icon color="#00ba57"
                                                       @click.stop="openQrCodeDialog(item)"
                                                >
                                                    <v-icon medium>qr_code</v-icon>
                                                </v-btn>
                                            </div>
                                            <div style="align-self: center">
                                                <v-btn flat icon color="red"
                                                       @click="onReferralLinkRemoved(item, index)"
                                                >
                                                    <v-icon medium>delete_outline</v-icon>
                                                </v-btn>
                                            </div>
                                        </v-layout>
                                    </v-container>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                        <v-list-tile v-if="!linksList.length">
                            <v-list-tile-content>
                                <v-list-tile-title class="text-center">
                                    Добавьте новую ссылку, нажав на значок плюса слева
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-card>
                <referral-link-dialog
                    v-model="showReferralLinkDialog"
                    :lastId="linksCount"
                    @save="onReferralLinkCreated($event)"
                />
                <qr-code-dialog
                    v-model="showQRCodeDialog"
                    :link="qrCodeLink"
                />
            </v-layout>

            <v-layout pt-5 pb-5 row wrap>
                <v-flex xs12 sm6>
                    <v-btn @click="validateWidgetTab"
                           class="submit-button block">Сохранить изменения</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container v-if="!widgetId" style="max-width: 1200px">
            <v-layout pt-5 pb-5 row wrap>
                <v-flex xs12 sm6>
                    <v-btn @click="createWidget"
                           class="submit-button block">Сгенерировать виджет</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
import QrCode from "../../fields/QrCode";
import QrCodeDialog from "./QrCodeDialog";
import ReferralLinkDialog from "./ReferralLinkDialog";

export default {
    name: "WidgetTab",
    components: {QrCode, ReferralLinkDialog, QrCodeDialog},
    props: ['widgetId', 'widgetLink', 'widgetCode', 'widgetQrUrl', 'widgetReferralLink', 'useReferral', 'linksList'],
    data: () => ({
        showReferralLinkDialog: false,
        showQRCodeDialog: false,
        qrCodeLink: '',
        linksCount: 0,
        deletedLinks: []
    }),
    created() {
        for (let v of this.linksList) {
            v.id = ++this.linksCount;
        }
    },
    methods: {
        validateWidgetTab() {
            if (this.$refs.widgetForm.validate()) {
                this.submitWidget();
            } else {
                this.$nextTick(function() {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    this.goToFirstError();
                });
            }
        },

        createWidget() {
            axios.post('/profile/widget').then(response => {
                if (response.data.status && response.data.status === 'ok') {
                    this.widgetId = response.data.id;
                    this.widgetCode = response.data.code;
                    this.widgetQrUrl = this.widgetLink = this.widgetReferralLink = response.data.referral;
                    this.useReferral = response.data.useReferral;
                } else {
                    console.log(response);
                    PNotify.error('Не удалось создать виджет.');
                }
            }).catch(error => {
                console.log(error);
                PNotify.error('Не удалось создать виджет.');
            })
        },

        submitWidget() {
            let data = {
                'widget_id': this.widgetId,
                'qr_url': this.widgetQrUrl,
                'use_referral': this.useReferral,
                'newReferralLinks': this.linksList.filter(el => {
                    return !el.uuid;
                }),
                'removedReferralLinks': this.deletedLinks
            };
            axios.patch('/profile/widget', data).then(response => {
                if (response.data.status && response.data.status === 'ok') {
                    const newLinks = response.data.newReferralLinks;
                    if (Array.isArray(newLinks) && newLinks.length) {
                        const newLen = newLinks.length;
                        this.linksList.map((item, idx) => {
                            for (let i = 0; i < newLen; i++) {
                                if (item.id === newLinks[i].id) {
                                    item.uuid = newLinks[i].uuid;
                                    item.getpolis_link = newLinks[i].getpolis_link;
                                    Vue.set(this.linksList, item, idx);
                                    return item;
                                }
                            }
                            return item;
                        });
                    }
                    this.deletedLinks = [];
                    PNotify.info('Виджет обновлён.');
                } else {
                    console.log(response);
                    PNotify.error('Не удалось обновить виджет.');
                }
            }).catch(error => {
                console.log(error);
                PNotify.error('Не удалось обновить виджет.');
            })
        },

        onUseReferralChange() {
            if (this.useReferral) {
                this.widgetQrUrl = this.widgetReferralLink;
            }
        },

        onReferralLinkCreated(e) {
            let temp = this.linksList.map(el => el);
            temp.push(e);
            this.linksList = temp;
            this.linksCount++;
        },

        openQrCodeDialog(item) {
            this.qrCodeLink = item.getpolis_link;
            this.showQRCodeDialog = true;
        },

        onReferralLinkRemoved(item, index) {
            let temp = this.linksList.map(el => el);
            temp.splice(index, 1);
            this.linksList = temp;
            if (item.uuid) {
                this.deletedLinks.push(item);
            }
        }
    }
}
</script>

<style scoped>
    .submit-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 20px !important;
        text-transform: none !important;
        box-shadow: none !important;

        height: 70px;
        background-color: #00ba57 !important;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
        padding: 0 !important;
        margin: 0;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    .submit-button >>> .v-btn__content {
        white-space: pre-wrap;
        padding: 0 50px;
        line-height: 1.1;
    }

    .widget-submit-button {
        height: 60px;
    }

    .widget-submit-button >>> .v-btn__content {
        padding: 0 30px;
    }

    /deep/ h1 {
        font-size: 65px;
        font-family: 'SFPro';
        line-height: 1.1;
        font-weight: 700;
        color: #000000;
    }

    /deep/ h2, h3 {
        font-family: 'SFProBold';
    }

    /deep/ h2 {
        font-size: 28px;
    }

    /deep/ h3 {
        font-size: 20px;
    }

    .widget-code {
        background-color: rgba(125, 141, 147, 0.07);
        padding: 24px;
        border-radius: 4px;
    }

    .toolbar-title {
        font-family: 'SFProBold';
        font-size: 20px;
    }

    .text-center {
        text-align: center
    }

    .nowrap-text {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/profile/WidgetTab.vue